export enum DocumentUploadFolderEnum {
  PO_SYSTEM_UPLOAD = 'PO_quote'
}


